<template>
    <div>
        <h1 class="font-weight-light" :class="titleClass">Chords Grid Editor</h1>

        <div class="title font-weight-light mt-3 grey--text">Version {{ version }}</div>
        <div class="subheading mt-4">
            {{ $t('author') }} : Fabien Bellanger
        </div>

        <div>
            <div class="mt-5 mb-3 title font-weight-light">{{ $t('made-with') }}</div>
            <div>
                <v-tooltip bottom>
                    <img src="../assets/logo_vuejs.png" height="50px" alt="Vue.js" class="logo"
                         @click="open('https://vuejs.org')" slot="activator" />
                    <span>Vue.js</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <img src="../assets/logo_vuetify.svg" height="50px" alt="Vuetify" class="logo"
                         @click="open('https://vuetifyjs.com/en/')" slot="activator" />
                    <span>Vuetify</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <img src="../assets/logo_svgjs.png" height="50px" alt="SVG.js" class="logo"
                         @click="open('https://svgjs.com')" slot="activator" />
                    <span>SVG.js</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <img src="../assets/logo_golang.png" height="50px" alt="Golang" class="logo"
                         @click="open('https://golang.org')" slot="activator" />
                    <span>Golang</span>
                </v-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/stores';

export default {
    store,
    computed: {
        ...mapGetters({
            version: 'version',
        }),
        titleClass: function()
        {
            return (this.$vuetify.breakpoint.name === 'xs') ? 'display-1' : 'display-3';
        },
    },
    methods: {
        /**
         * Ouverture du lien
         *
         * @author Fabien Bellanger
         * @param {String} url URL
         */
        open: function(url)
        {
            window.open(url);
        },
    },
};
</script>

<style scoped lang="scss">
    .logo {
        margin: 0px 20px;
        cursor: pointer;
    }
</style>
